import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';

export default class SupplierNewAccountSetupPage extends React.Component<any, null> {
	render() {
		return (
			<div>
				<Route
					path="/supplier/newAccountSetup"
					exact={true}
					render={(props) => (
						<Redirect
							to={{
								pathname: '/supplier/newAccountSetup/association',
							}}
						/>
					)}
				/>
				{this.props.childRoutes.map((r, i) => (
					<RouteWithSubRoutes key={i} {...r} />
				))}
			</div>
		);
	}
}
